import React from 'react'

import {HashRouter, Routes, Route} from 'react-router-dom'
import Ingreso from './components/ingreso.component';

import bg from './UI/Intro.webp'
import logoProyecto from './UI/Logos/logo-proyecto.svg'
import rotation from './UI/icons/RotationScreen/rotation.png'

import { MAQUETA_ROUTE } from './config/routes';

interface Props{}

interface State{}

class App extends React.Component <Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {}
    }

    render(): React.ReactNode {
        return(
            <HashRouter>
                <div className='main-masterplan-page'>
                    <Routes>
                        <Route path={MAQUETA_ROUTE} element={<Ingreso/>}/>
                    </Routes>
                </div>
                <div className="portrait-rotation">
                    <img src={bg} className="background-portrait"></img>
                    <div className="cover-portrait">
                        <img src={logoProyecto} className="logo-castelo-portrait"></img>
                        <img src={rotation} className="rotation-portrait"></img>
                        <div className="text-portrait">
                        <p className="p-text-portrait">ROTA TU DISPOSITIVO</p>
                        <p className="s-text-portrait">para disfrutar la experiencia</p>
                        </div>
                    </div>
                </div>
            </HashRouter>
        )
    }
}

export default App